import { axiosInstance as request } from '@api/rest.service'

const api = id => `/subscription-periods/${id}`

/**
 * @description GET /subscription-periods/{id}/stakes
 * @returns {AxiosPromise<any>}
 */
export const GET_STAKES_FOR_SUBSCRIPTION_PERIOD = id => request.get(`${api(id)}/stakes`)

/**
 * @description POST /subscription-periods/${id}/departments-stakeholders
 * @returns {AxiosPromise<any>}
 */
export const CREATE_SUBSCRIPTION_PERIOD_DEPARTMENTS_STAKEHOLDERS = (id, payload) =>
  request.post(`${api(id)}/departments-stakeholders`, payload)

/**
 * @description POST /subscription-periods/${id}/departments
 * @returns {AxiosPromise<any>}
 */
export const ADD_DEPARTMENT_TO_SUBSCRIPTION_PERIOD = (id, depId, percentage, costCenterId) =>
  request.post(`${api(id)}/departments`, {
    percentage,
    department_id: depId,
    cost_center_id: costCenterId
  })

/**
 * @description PUT /subscription-periods/{id}/departments/{id}
 * @returns {AxiosPromise<any>}
 */
export const UPDATE_SUBSCRIPTION_PERIOD_STAKE = (subId, depId, payload) =>
  request.put(`${api(subId)}/departments/${depId}`, payload)

/**
 * @description DELETE /subscription-periods/{id}/departments/{id}
 * @returns {AxiosPromise}
 */
export const DELETE_SUBSCRIPTION_PERIOD_DEPARTMENT = (subId, depId) =>
  request.delete(`${api(subId)}/departments/${depId}`)

/**
 * @description POST /subscription-periods/{id}/stakeholders
 * @returns {AxiosPromise<any>}
 */
export const ADD_STAKEHOLDER_TO_SUBSCRIPTION_PERIOD = (subId, departmentId, stakeholderId, stakeId) =>
  request.post(`${api(subId)}/stakeholders`, {
    department_id: departmentId,
    stakeholder_id: stakeholderId,
    department_stake_id: stakeId
  })

/**
 * @description DELETE /subscription-periods/{id}/stakeholders/{id}
 * @returns {AxiosPromise<any>}
 */
export const DELETE_SUBSCRIPTION_PERIOD_STAKEHOLDER = (subId, stakeId, departmentId) =>
  request.delete(`${api(subId)}/stakeholders/${stakeId}`, { data: { department_stake_id: departmentId } })
